<ion-item button class="subitem" lines="inset" detail="false" routerLink="/admin" [queryParams]="{cmd:'users_active'}">
    <ion-label>{{'admin.users_active' | translate}}</ion-label>
</ion-item>
<ion-item button class="subitem" lines="inset" detail="false" routerLink="/admin"
          [queryParams]="{cmd:'users_inactive'}">
    <ion-label>{{'admin.users_inactive' | translate}}</ion-label>
</ion-item>
<ion-item button class="subitem" lines="inset" detail="false" routerLink="/admin" [queryParams]="{cmd:'add_user'}">
    <ion-label>{{'admin.add_user' | translate}}</ion-label>
</ion-item>
<ion-item button class="subitem" lines="inset" detail="false" routerLink="/admin"
          [queryParams]="{cmd:'edit_department'}">
    <ion-label>{{'admin.edit_department' | translate}}</ion-label>
</ion-item>
<ion-item button class="subitem" lines="inset" detail="false" routerLink="/admin" [queryParams]="{cmd:'add_category'}">
    <ion-label>{{'admin.add_category' | translate}}</ion-label>
</ion-item>
